/** @typedef {Object} ALKChangePassword
 * @property {String} oldPassword
 * @property {String} newPassword
 */

(function () {
  "use strict";

  angular
    .module("alk.authentication")
    .factory("ALKChangePassword", ALKChangePassword);

  /** @name ALKChangePassword
   * @ngdoc factory
   * @description A factory for an object that encapsulates change password requests.
   * @param {String} oldPassword - existing password for the user
   * @param {String} newPassword - new password for the user
   * @example
   * var change = new ALKChangePassword(oldPassword, newPassword);
   * @returns ALKChangePassword
   * @memberof alk.authentication
   */
  function ALKChangePassword() {
    return function (oldPassword, newPassword) {
      this.oldPassword = oldPassword;
      this.newPassword = newPassword;
    };
  }
})();



// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-authentication/factories/changePassword.factory.js